import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function ProtectedRoute({ children }: { children:React.ReactNode }) {
  const { loading, isAuthenticated } = useAuth()
  const location = useLocation()
  if (loading) return <div className="screen-loader"><span className="loader-ring"/><p>Loading your study space…</p></div>
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from:location.pathname }} />
  return <>{children}</>
}

export function AdminRoute({ children }: { children:React.ReactNode }) {
  const { loading, isAuthenticated, isAdmin } = useAuth()
  if (loading) return <div className="screen-loader"><span className="loader-ring"/><p>Opening admin workspace…</p></div>
  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (!isAdmin) return <Navigate to="/app" replace />
  return <>{children}</>
}
